import React from "react";
import LogoLoader from "./LogoLoader";

const LoadingSpinner = () => {
  return <LogoLoader fullScreen label="Opening Jhonks" />;
};

export default LoadingSpinner;
